export default __webpack_public_path__ + "static/montazh-vosmigrannoj-piramidy-s-mednoj-zhestyu-s-pomoshchyu-krana-a891d838e4ad3085534f34ba55b822c5.jpg";